const developmentConfig = {
  env: 'development',
  apiUrl: 'http://localhost',
  sentryDsn: '',
  clarityProjectId: '',
  gaId: '',
  payfastUrl: 'https://sandbox.payfast.co.za/eng/process',
};

const stagingConfig = {
  env: 'staging',
  apiUrl: 'https://api-staging.sportpix.co.za',
  sentryDsn: 'https://e7b7150e961078bd5038dde7d21f84c5@o4509261195968512.ingest.de.sentry.io/4509261224214608',
  clarityProjectId: 're80o2kwze',
  gaId: '',
  payfastUrl: 'https://sandbox.payfast.co.za/eng/process',
};

const productionConfig = {
  env: 'production',
  apiUrl: 'https://api.sportpix.co.za',
  sentryDsn: 'https://e7b7150e961078bd5038dde7d21f84c5@o4509261195968512.ingest.de.sentry.io/4509261224214608',
  clarityProjectId: 're7t331ujy',
  gaId: 'G-2HD02B5NG2',
  payfastUrl: 'https://www.payfast.co.za/eng/process',
};

let config;
// This check is crucial to prevent errors during SSG build where `window` is not available.
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  if (hostname === 'sportpix.co.za') {
    config = productionConfig;
  } else if (hostname === 'staging.sportpix.co.za') {
    config = stagingConfig;
  } else if (hostname === 'localhost') {
    config = developmentConfig;
  } else {
    config = productionConfig;
  }
} else {
  // Provide a fallback for the Node.js (SSG) environment.
  // This is less critical now for API calls but good for consistency.
  config = productionConfig;
}

export default config;
